$(document).ready(function () {
    const sliderHomeFoto = () => {
        const homeSliderFoto = document.querySelectorAll('.slider-foto'); // container above slider
        homeSliderFoto.forEach(sliderWrapper => {
            const slider = sliderWrapper.querySelector('.slider-foto__sl'); // container with slider
            const controlsContainerD = sliderWrapper.querySelector('.slider-control');

            const sliderHomeFotos = tns({
                container: slider,
                mouseDrag: true,
                nav: false,
                loop: false,
                controlsContainer: controlsContainerD,
                responsive: {
                    350: {
                        items: 1,
                        gutter: 0,

                    },
                    500: {
                        items: 3.5,
                        gutter: 50,
                    }
                }
            });
        });
    };

    if($('.slider-foto__sl').length > 0) {
        sliderHomeFoto();
    }

    const sliderHomeTexto = () => {
        const homeSliderFoto = document.querySelectorAll('.slider-text'); // container above slider
        homeSliderFoto.forEach(sliderWrapper => {
            const slider = sliderWrapper.querySelector('.slider-text__sl'); // container with slider
            const controlsContainerD = sliderWrapper.querySelector('.slider-control');

            const sliderHomeTxt = tns({
                container: slider,
                mouseDrag: true,
                nav: false,
                loop: false,
                controlsContainer: controlsContainerD,
                responsive: {
                    350: {
                        items: 1,
                        gutter: 0,

                    },
                    500: {
                        items: 3,
                        gutter: 50,
                    }
                }
            });


        });
    };

    if($('.slider-text__sl').length > 0) {
        sliderHomeTexto();
    }

    if($('.programas').length > 0) {
        const sliderHomeProgramas = tns({
            container: '.programas__sl',
            mouseDrag: true,
            nav: false,
            loop: false,
            items: 1,
            mode: 'gallery',
            speed: 1200,
            controlsContainer: '.programas .slider-control',
        });

        sliderHomeProgramas.events.on('transitionStart', function (info, eventName) {
            $('.programas .images a').removeClass('active');
            $('.programas .images a').eq(info.index).addClass('active');
        });
    }

    gsap.utils.toArray(".panel").forEach((panel, i) => {
        let trigger = ScrollTrigger.create({
            trigger: panel,
            start: "top",
            pin: i < 1 ? true : false,
            //pin: true,
            pinSpacing: false,

        });
    });

    $('.accordeon .next').on('click', function (e) {
        e.preventDefault();

        $('.accordeon .prev').attr('aria-disabled', false);

        var next = $(this).data('next');

        if (next <= 3) {
            //prev
            $('.accordeon .prev').data('prev', next - 1);

            $('.accordeon .slide').removeClass('slide--expanded');
            $('.accordeon .slide').eq(next - 1).addClass('slide-prev');
            $('.accordeon .slide').eq(next - 1).find('.conteudo').hide();

            $('.accordeon .slide').eq(next).addClass('slide--expanded');

            setTimeout(function () {
                $('.accordeon .slide').eq(next).find('.conteudo').fadeIn();
            }, 400);


            $(this).data('next', next + 1);
        }

        if (next == 3) {
            $(this).attr('aria-disabled', true);
        }
    });

    $('.accordeon .prev').on('click', function (e){
        e.preventDefault();

        $('.accordeon .next').attr('aria-disabled', false);

        var prev = $(this).data('prev');

        if (prev >= 0) {
            //prev
            $('.accordeon .next').data('next', prev + 1);

            $('.accordeon .slide').removeClass('slide--expanded');
            $('.accordeon .slide').eq(prev).addClass('slide--expanded');
            $('.accordeon .slide').eq(prev).removeClass('slide-prev');
            $('.accordeon .slide').eq(prev + 1).find('.conteudo').hide();

            setTimeout(function () {
                $('.accordeon .slide').eq(prev).find('.conteudo').fadeIn();
            }, 400);

            $(this).data('prev', prev - 1);
        }


        if (prev == 0) {
            $(this).attr('aria-disabled', true);
        }
    });

    // $('.bubble').hover(function () {
    //     $(this).remove();
    // });

    gsap.to(".accordeon", {
        scrollTrigger: {
            trigger: ".accordeon",
            start: "top 20%",
            end: "bottom 10%",
            //markers: true,
            scrub: 1,
            onEnter: () => {
                $('.ch-menu').removeClass('none');

                setTimeout(function () {
                    $('.ch-menu').removeClass('esconde');
                });
            },
        }
    });

    if($('.menu-aberto-home').length > 0) {
        gsap.to(".menu-aberto-home", {
            scrollTrigger: {
                trigger: ".menu-aberto-home",
                start: "top 25%",
                end: "bottom 20%",
                //once: true,
                //markers: true,
                scrub: 1,
                onEnter: () => {
                    $('.submenu').fadeIn();
                },
                onLeave: () => {
                    if($(window).width() > 768) {
                        $('.submenu').addClass('open');
                        $('.submenu .btn').removeClass('menor');
                    }
                },
                onEnterBack: () => {
                    $('.submenu').removeClass('open');
                    $('.submenu .btn').addClass('menor');
                },
            }
        });
    }




    // $('.enter-site a').on('click', function (e){
    //     e.preventDefault();
    //
    //     $('.ch-abertura').fadeOut(function (){
    //         $('body.home').css('overflow', 'auto');
    //     });
    //
    //
    // })
    //
    // $('body.home').bind('mousewheel', function(e) {
    //     $('.ch-abertura').fadeOut(function (){
    //         $('body.home').css('overflow', 'auto');
    //     });
    // });
})